import { montserrat } from '@/app/fonts'
import { SquircleAdapter } from '../SquircleAdapter'

import './styles.scss'

export type TextareaProps = {
  label?: string
  wrapperStyle?: React.CSSProperties
} & React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
>

export function Textarea({
  label,
  name,
  value,
  wrapperStyle,
  ...rest
}: TextareaProps) {
  return (
    <div className="textarea-container" style={wrapperStyle}>
      {!!label && <label htmlFor={name}>{label}</label>}

      <SquircleAdapter
        cornerRadius={16}
        className="textarea-container__wrapper"
      >
        <textarea value={value} {...rest} style={montserrat.style} />
      </SquircleAdapter>
    </div>
  )
}
